import { AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery } from '@festina/life-general-types/life/hooks/AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery'

export const useFetchAnnotationCommands =
  AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery.useSuspenseQuery
